/**
 * The content model of the "Wie lese ich diesen Bericht?" panel: seven topics,
 * each a heading plus its body lines, as translation keys.
 *
 * Kept out of `Explainer.tsx` so that file exports a component and nothing
 * else — the same split as `components/provenance.ts` — and so a test can
 * import the model on its own and assert what the panel is obliged to cover.
 */
import type { TranslationKey } from '@/i18n'

export interface ExplainerTopic {
  id: string
  title: TranslationKey
  body: TranslationKey[]
}

export const EXPLAINER_TOPICS: readonly ExplainerTopic[] = [
  {
    id: 'lights',
    title: 'explainer.lights.title',
    body: ['explainer.lights.body', 'explainer.lights.note'],
  },
  {
    id: 'confidence',
    title: 'explainer.confidence.title',
    body: [
      'explainer.confidence.body',
      'explainer.confidence.deterministic',
      'explainer.confidence.retrieval',
      'explainer.confidence.indicator',
    ],
  },
  {
    id: 'numbers',
    title: 'explainer.numbers.title',
    body: ['explainer.numbers.body', 'explainer.numbers.example'],
  },
  { id: 'skipped', title: 'explainer.skipped.title', body: ['explainer.skipped.body'] },
  { id: 'indicative', title: 'explainer.indicative.title', body: ['explainer.indicative.body'] },
  { id: 'nachweise', title: 'explainer.nachweise.title', body: ['explainer.nachweise.body'] },
  { id: 'liability', title: 'explainer.liability.title', body: ['explainer.liability.body'] },
]
